/**
 * ADR-013 §3.1 — Normalização canônica de document_type.
 *
 * Vocabulário canônico vive em tipos_documento.value (banco). Esta função
 * mapeia valores legados (proposta_comercial, matricula_imovel,
 * contrato_social) para o vocabulário canônico e deixa passar valores já
 * canônicos. Valores desconhecidos viram 'other' — preservam idempotência
 * sem inventar enum novo.
 *
 * Use em TODOS os pontos de escrita em:
 *   - intake_runs.document_type
 *   - email_attachments.document_type
 */

const DOCUMENT_TYPE_MAP = {
  // Legados → canônico
  proposta_comercial: 'proposal',
  proposta: 'proposal',
  matricula_imovel: 'land_title',
  matricula: 'land_title',
  contrato_social: 'corporate_charter',
  alteracao_contratual: 'corporate_charter',
  certidao: 'certificate',

  // Canônicos (pass-through)
  proposal: 'proposal',
  contract: 'contract',
  land_title: 'land_title',
  corporate_charter: 'corporate_charter',
  jucesp_filing: 'jucesp_filing',
  certificate: 'certificate',
  iptu: 'iptu',
  due_diligence: 'due_diligence',
  appraisal: 'appraisal',
  feasibility: 'feasibility',
  financial_model: 'financial_model',
  site_photo: 'site_photo',
  presentation: 'presentation',
  meeting_notes: 'meeting_notes',
  correspondence: 'correspondence',
  other: 'other',
};

export function normalizeDocumentType(raw) {
  if (!raw) return null;
  const lower = String(raw).toLowerCase().trim();
  if (!lower) return null;
  return DOCUMENT_TYPE_MAP[lower] || 'other';
}
